import { render, staticRenderFns } from "./PatientAiReports.vue?vue&type=template&id=bd307244&scoped=true"
import script from "./PatientAiReports.vue?vue&type=script&lang=js"
export * from "./PatientAiReports.vue?vue&type=script&lang=js"
import style0 from "./PatientAiReports.vue?vue&type=style&index=0&id=bd307244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd307244",
  null
  
)

export default component.exports